import { render, staticRenderFns } from "./ManageExternalEntities.vue?vue&type=template&id=2d6970e2"
import script from "./ManageExternalEntities.vue?vue&type=script&lang=js"
export * from "./ManageExternalEntities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports